import { CLIENT_GEN_OTP, CLIENT_GEN_OTP_ERROR, CLIENT_GEN_OTP_HIDE_ERROR, CLIENT_GEN_OTP_START_LOADER, CLIENT_GEN_OTP_STOP_LOADER, } from "../interface/IClientGenOTP";
const initState = {
    data: {
        message: "",
        OTPSent: false,
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const ClientGenOTP = (state = initState, action) => {
    switch (action.type) {
        case CLIENT_GEN_OTP: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case CLIENT_GEN_OTP_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case CLIENT_GEN_OTP_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case CLIENT_GEN_OTP_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case CLIENT_GEN_OTP_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default ClientGenOTP;
